module.exports = __webpack_public_path__ + "static/img/flowers.431e98d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/flowers.png
// module id = R1ET
// module chunks = 0